/**
 * Created by v-grfore on 17/09/2016.
 * Container class, orchestrates how the wbs renderer and wbs layout operate together.
 */
import "../css/main.css";
import * as React from "react";
import MouseEventHandler = React.MouseEventHandler;
import MouseEvent = React.MouseEvent;


// import { WbsComponent, NodesData } from "./WbsComponent";
// import { WbsEdge, EdgesData } from "./WbsEdge";
import { WbsComponent, TextDimensions } from "./WbsComponent";
import { WbsEdge } from "./WbsEdge";
import { WbsLayout, BBoxRectangle } from "../layout/WbsLayout";
import { AddWbsComponentEvents, SelectNodeEvents, EditNodeEvents } from "../WbsEvents";
import { SVGHelpers, STRING_TO_MEASURE} from '../SvgHelpers';
import { CssClassAndIdNames, Names, ClassAndIdNames } from "../CssClassAndIdNames";

//import * as SvgMap2 from './SvgMap2';

// export interface GraphStructure {
//   nodes: NodesData;
//   edges: EdgesData;
// }

export interface PropsAuthorizations {
  canRename?: boolean;
  canAddChild?: boolean;
}

export interface WbsProps extends AddWbsComponentEvents, SelectNodeEvents, EditNodeEvents, PropsAuthorizations {
  graph: any;
}

export const Wbs: React.SFC<WbsProps> = props => {

  const layout: any = WbsLayout.calculate(props.graph);  
  const maxWidth: number = Math.abs(Math.max.apply(Math, layout.wbsComponents.map((component: any) => {return component.wbsComponentBox.x;}))) + 300; //TODO refactor without 200
  const maxHeight: number = Math.abs(Math.max.apply(Math, layout.wbsComponents.map((component: any) => {return component.wbsComponentBox.y;}))) + 90; //TODO refactor without 90
  const titleTestStringDimensions: SVGRect = SVGHelpers.getSvgTextBoxDimensions(STRING_TO_MEASURE, CssClassAndIdNames.getClassName(Names.WbsComponent_Title));
  const wbsIdTestStringDimensions: SVGRect = SVGHelpers.getSvgTextBoxDimensions(STRING_TO_MEASURE, CssClassAndIdNames.getClassName(Names.WbsComponent_WbsId));
  const labelTestStringDimensions: SVGRect = SVGHelpers.getSvgTextBoxDimensions(STRING_TO_MEASURE, CssClassAndIdNames.getClassName(Names.WbsComponent_DataLabel));

  const textDimensions: TextDimensions = {
    title: {
      width: titleTestStringDimensions.width,
      height: titleTestStringDimensions.height
    },
    id: {
      width: wbsIdTestStringDimensions.width,
      height: wbsIdTestStringDimensions.height
    },
    label: {
      width: labelTestStringDimensions.width,
      height: labelTestStringDimensions.height
    }
  };

  const wbsComponents: any = layout.wbsComponents.map((component: any) =>
    <WbsComponent
      key={component.wbsComponentBox.nodeId}
      textDimensions={textDimensions}      
      wbsComponentId={component.wbsComponentId.text}
      wbsComponentTitle={component.wbsComponentTitle.text}
      nodeId={component.wbsComponentBox.nodeId}
      x={component.wbsComponentBox.x}
      y={component.wbsComponentBox.y}
      width={component.wbsComponentBox.width}
      height={component.wbsComponentBox.height}
      wbsComponentWork={component.wbsComponentWork}
      wbsComponentCost={component.wbsComponentCost}
      issueCount={component.issueCount}
      riskCount={component.riskCount}
      todoCount={component.todoCount}
      communicationCount={component.communicationCount}

      canAddChild={props.canAddChild}
      canRename={props.canRename}
      onAddChild={props.onAddChild}
      onInsertParent={props.onInsertParent}
      onAddSiblingBefore={props.onAddSiblingBefore}
      onAddSiblingAfter={props.onAddSiblingAfter}
      onComponentSelected={props.onComponentSelected}
      onComponentOpenMenu={props.onComponentOpenMenu}
      onTitleEditRequest={props.onTitleEditRequest}
    />
  );

  const wbsEdges: any = layout.wbsEdges.map((edge: any) =>
    <WbsEdge
      key={edge.edgeId}
      edgeId={edge.edgeId}
      sourceWbsComponentData={edge.sourceWbsComponentData}
      targetWbsComponentData={edge.targetWbsComponentData}
    />
  );

  const x: number = layout.wbsComponents[0].wbsComponentBox.x + 60;
  const y: number = layout.wbsComponents[0].wbsComponentBox.y;
  const title: string = layout.wbsComponents[0].wbsComponentTitle.text;

  return (
    <svg height={maxHeight+20} width={maxWidth+20} id="wbs">
      {wbsEdges}
      {wbsComponents}
    </svg>
  );
};

/*
<svg height={maxHeight} viewBox={`0 0 ${maxWidth} ${maxHeight}`} id="wbs">
  {wbsEdges}
  {wbsComponents}
</svg>
*/


// WEBPACK FOOTER //
// ./src/components/Wbs.tsx